


















import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";

@Component({})
export default class NoProductOffer extends Vue {
  @Prop({ required: true }) componentTitle!: string;
  @Prop({ required: true }) text!: string;
  @Prop({ required: true }) link!: string;
  @Prop({ required: true }) imageSrc!: string;
  @Prop({ required: true }) imageAlt!: string;
  @Prop({ default: false }) useAltButtonStyle!: boolean;

  openLink () {
    window.open(this.link, "_blank", "noopener,noreferrer");
  }
}
